import { faCircleDollarToSlot } from '@fortawesome/pro-light-svg-icons';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { Heading } from '~/components/molecules/Heading';
import { AppBreadcrumbs } from '~/components/organisms/Breadcrumbs';
import { IapPollList } from '~/components/organisms/IapPollList';

export type IAppIapPollsPageProps = {
  appId: string;
};

export const AppIapPollsPage: React.FC<IAppIapPollsPageProps> = (props) => {
  const { appId } = props;
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('AppIapPollsPage.seo.title')}</title>
      </Helmet>

      <AppBreadcrumbs appId={appId} />

      <Heading
        icon={<FontAwesomeIcon icon={faCircleDollarToSlot} />}
        title={t('AppIapPollsPage.title')}
        subtitle={t('AppIapPollsPage.subtitle')}
        actions={
          <Button
            href={`/apps/${appId}/iapPolls/create`}
            icon={<FontAwesomeIcon icon={faPlus} />}
          >
            {t('AppIapPollsPage.create')}
          </Button>
        }
      />

      <IapPollList appId={appId} />
    </>
  );
};
